import useSlice from '~/utils/slice/hook';
import React, { useEffect, useState } from 'react';
import { find } from 'lodash';
import { PageTitle, Button } from '@cordata/buffet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import { UncontrolledTable } from '../../../components/common';

const DivisionLogosIndex = () => {
  const history = useHistory();
  const [availableOrganizations, setAvailableOrganizations] = useState([]);
  const [availableDivisions, setAvailableDivisions] = useState([]);

  const { fetch } = useSlice();

  const defaultSorted = [{
    id: 'org',
  }];

  useEffect(() => {
    fetch('organization')
      .then(r => r.data.data)
      .then(setAvailableOrganizations);

    fetch('division')
      .then(r => r.data.data)
      .then(setAvailableDivisions);
  }, []);

  const tableColumns = [{
    id: 'org',
    Header: 'Organization',
    accessor: (item) => {
      if (availableOrganizations.length && item.attributes.orgUid) {
        const org = find(availableOrganizations, ['id', item.attributes.orgUid]);
        return org && org.attributes.orgName;
      }
      return '';
    },
  }, {
    id: 'division',
    Header: 'Division',
    accessor: (item) => {
      if (availableDivisions.length && item.attributes.divisionUid) {
        const div = find(availableDivisions, ['id', item.attributes.divisionUid]);
        return div && div.attributes.divisionName;
      }
      return '';
    },
  }, {
    id: 'logo',
    Header: 'Logo',
    Cell: row => (
      <div style={{ height: '100px', width: '100%', overflow: 'hidden' }}>
        <img src={row.original.attributes.imageLink} alt="No link" />
      </div>
    ),
    filterable: false,
    sortable: false,
  }];

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to="/organization/division-logos/add"
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Division Logo</span>
          </Button>
          }
      >
        Division Logos
      </PageTitle>

      <UncontrolledTable
        name="division-logos"
        defaultSorted={defaultSorted}
        endpoint={{
            url: 'admin/division-logo',
          }}
        columns={tableColumns}
        getTrProps={(state, rowInfo) => ({
            style: {
              cursor: 'pointer',
            },
            onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/organization/division-logos/${rowInfo.original.id}`)),
          })}
      />
    </>
  );
};

export default DivisionLogosIndex;
